require(["jquery", "jquery/ui", "loader", "FrkBusinessCard"], function ($, mod1, mod2, FrkBusinessCard) {
    $(document).ready(function () {
        // Init
        const isDisplayed =
            $("body.category-hasznalt-targoncak").length > 0 || $("button#product-addtocart-button").length === 0;
        if (isDisplayed) {
            FrkBusinessCard.loadTo("gyuri", ".product-media:nth-child(1)");
        }
    });
});
